export const PAGES_PATH = {
  HEALTH: "/health",
  PAST_PETS: "past-pets",

  MY_VISITS: "/my-visits",
  DASHBOARD: "/dashboard",
  LANDING: "/",
  POC: "/poc-smart-card",
  SIGN_IN: "/sign-in",
  SIGN_UP: "/sign-up",
  TERMS_CONDITIONS: "/terms-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  VERSIONS: "/versions",
  USER_PROFILE: "/user-profile",
  EDIT_PROFILE: "edit",
  USER_BILLING: "payment",
  CHANGE_HOSPITAL: "hospital",
  PET_CARE: "/pet-care",
  STORE: "/store",
  BILLING_METHOD: "method",
  BILLING_HISTORY: "history",
  PROFILE_COMPLETION: "/profile-completion",
  PET_PROFILE: "/pet-profile",
  NOTIFICATION_SETTINGS: "notification-settings",
  MANAGE_PLAN: "/manage-plan",
  WELLNESS_PLAN_DETAILS: "/wellness-plan-details",
  WELLNESS_PLAN_CONFIRM_AND_PAY: "/wellness-plan-payment",
  WELLNESS_PLAN_MANAGE: "/manage-wellness-plan",
  OTP_VERIFICATION: "/otp-verification",
  ADD_PHONE_NUMBER: "/add-phone-number",
  REFER_FRIEND: "/refer-friend",
  PAST_PLANS: "past-plans",
  PREQUALIFICATION: "/prequalification",
  COMPLETE_PURCHASE: "/complete-purchase",
  COMPLETE_PURCHASE_CHECKOUT: "/complete-purchase/:id",
};

// TODO: Delete this object after cleaning up unused sing in pages/components
export const STEP_NAME_PATH = {
  ONBOARDING_SELECT: "select",
  CREATE_PROFILE: "profile",
  PASSWORD_CREATE: "password",
  PASSWORD_RESET: "password-reset",
  RESET_PASSWORD: "reset-password",
  CHECK_INBOX_ACCOUNT: "check-your-inbox-account",
  CHECK_INBOX_PASSWORD: "check-your-inbox-password",
  CHECK_INBOX_RETRY: "check-your-inbox-retry",
  CALL_GOODVETS: "call-goodvets",
  USER_FOUND_INSTRUCTION: "user-found-instruction",
  USER_FOUND_PASSWORD: "user-found-password",
  DIDNT_FIND_YOU: "did-not-find-you",
  CREATE_PROFILE_V2: "profile-v2",
  OTP_VERIFICATION: "otp-verification",
};

// Rechedule modal trigger page
export const RESCHEDULE_SOURCE = {
  DASHBOARD: "dashboard",
  RESCHEDULE_ICON: "icon",
};

export const CUSTOMER_REFERRAL_SOURCES = {
  AFTER_BOOKING: "after_booking",
  AFTER_REVIEW: "after_review",
};
export const BREADCRUMBS: {
  [key: string]: string;
} = {
  [PAGES_PATH.DASHBOARD]: "Home",
};

type IPageTitleProps = {
  [key: string]: {
    pageTitle: string;
    showBackButton: boolean;
    showNotificationIcon: boolean;
  };
};

export const PAGE_TITLE_TO_PATH_MAPPING: IPageTitleProps = {
  "/dashboard": {
    pageTitle: "Welcome",
    showBackButton: false,
    showNotificationIcon: true,
  },
  "/pet-care": {
    pageTitle: "Care",
    showBackButton: false,
    showNotificationIcon: true,
  },
  "/store": {
    pageTitle: "Pharmacy Orders",
    showBackButton: false,
    showNotificationIcon: true,
  },
  "/user-profile": {
    pageTitle: "My Account",
    showBackButton: false,
    showNotificationIcon: true,
  },
  "/user-profile/edit": {
    pageTitle: "Edit Profile",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/user-profile/past-pets": {
    pageTitle: "Past Pets",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/user-profile/payment": {
    pageTitle: "Plan & Billing",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/user-profile/payment/method": {
    pageTitle: "Payment Methods",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/user-profile/payment/history": {
    pageTitle: "Payment History",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/user-profile/hospital": {
    pageTitle: "Change Home Hospital",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/user-profile/notification-settings": {
    pageTitle: "Notifications Settings",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/pet-profile": {
    pageTitle: "Edit Profile",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/wellness-plan-details": {
    pageTitle: "Choose Your Subscription",
    showBackButton: true,
    showNotificationIcon: false,
  },
  "/wellness-plan-details/wellness-plan-payment": {
    pageTitle: "Choose Your Billing Option",
    showBackButton: true,
    showNotificationIcon: false,
  },
  "/manage-plan": {
    pageTitle: "Manage Plan",
    showBackButton: true,
    showNotificationIcon: false,
  },
  "/user-profile/payment/past-plans": {
    pageTitle: "Past Plans",
    showBackButton: true,
    showNotificationIcon: true,
  },
  "/refer-friend": {
    pageTitle: "Refer a Friend",
    showBackButton: false,
    showNotificationIcon: true,
  },
  "/wellness-plan-details/all-plans": {
    pageTitle: "All Plans",
    showBackButton: true,
    showNotificationIcon: false,
  },
  "/prequalification": {
    pageTitle: "Submit Your Request",
    showBackButton: true,
    showNotificationIcon: false,
  },
  "/complete-purchase": {
    pageTitle: "Complete Your Purchase",
    showBackButton: false,
    showNotificationIcon: false,
  },
};
